import { createReducer, on } from '@ngrx/store';
import { createDefaultLoadable, onLoadableError, onLoadableLoad, onLoadableSuccess } from '../../common/models/loadable';
import { AlertReportTemplateActions } from './alert-report-template.actions';
import { initialAlertReportTemplateState } from './alert-report-template.state';

export const alertReportTemplateReducer = createReducer(
  initialAlertReportTemplateState,
  on(AlertReportTemplateActions.loadTemplates, (state) => ({
    ...state,
    templates: onLoadableLoad(state.templates)
  })),
  on(AlertReportTemplateActions.loadTemplatesSuccess, (state, { templates }) => ({
    ...state,
    templates: { ...onLoadableSuccess(state.templates), items: templates }
  })),
  on(AlertReportTemplateActions.loadTemplatesFailure, (state, { error }) => ({
    ...state,
    templates: onLoadableError(state.templates, error)
  })),
  on(AlertReportTemplateActions.loadComponentTypes, (state) => ({
    ...state,
    componentTypes: onLoadableLoad(state.componentTypes)
  })),
  on(AlertReportTemplateActions.loadComponentTypesSuccess, (state, { componentTypes }) => ({
    ...state,
    componentTypes: { ...onLoadableSuccess(state.componentTypes), items: componentTypes }
  })),
  on(AlertReportTemplateActions.loadComponentTypesFailure, (state, { error }) => ({
    ...state,
    componentTypes: onLoadableError(state.componentTypes, error)
  })),
  on(AlertReportTemplateActions.createTemplate, (state) => ({
    ...state,
    create: { ...onLoadableLoad(state.create), template: null }
  })),
  on(AlertReportTemplateActions.createTemplateSuccess, (state, { template }) => ({
    ...state,
    create: { ...onLoadableSuccess(state.create), template }
  })),
  on(AlertReportTemplateActions.createTemplateFailure, (state, { error }) => ({
    ...state,
    create: { ...onLoadableError(state.create, error), template: null }
  })),
  on(AlertReportTemplateActions.resetCreate, (state) => ({
    ...state,
    create: { ...createDefaultLoadable(), template: null }
  })),
  on(AlertReportTemplateActions.deleteTemplate, (state) => ({
    ...state,
    delete: onLoadableLoad(state.delete)
  })),
  on(AlertReportTemplateActions.deleteTemplateSuccess, (state) => ({
    ...state,
    delete: onLoadableSuccess(state.delete)
  })),
  on(AlertReportTemplateActions.deleteTemplateFailure, (state, { error }) => ({
    ...state,
    delete: onLoadableError(state.delete, error)
  })),
  on(AlertReportTemplateActions.resetDelete, (state) => ({
    ...state,
    delete: createDefaultLoadable()
  })),
  on(AlertReportTemplateActions.previewTemplate, (state) => ({
    ...state,
    preview: { ...onLoadableLoad(state.preview), html: null }
  })),
  on(AlertReportTemplateActions.previewTemplateSuccess, (state, { html }) => ({
    ...state,
    preview: { ...onLoadableSuccess(state.preview), html }
  })),
  on(AlertReportTemplateActions.previewTemplateFailure, (state, { error }) => ({
    ...state,
    preview: { ...onLoadableError(state.preview, error), html: null }
  })),
  on(AlertReportTemplateActions.resetPreview, (state) => ({
    ...state,
    preview: { ...createDefaultLoadable(), html: null }
  })),
  on(AlertReportTemplateActions.generateReport, (state) => ({
    ...state,
    generate: onLoadableLoad(state.generate)
  })),
  on(AlertReportTemplateActions.generateReportSuccess, (state) => ({
    ...state,
    generate: onLoadableSuccess(state.generate)
  })),
  on(AlertReportTemplateActions.generateReportFailure, (state, { error }) => ({
    ...state,
    generate: onLoadableError(state.generate, error)
  })),
  on(AlertReportTemplateActions.resetGenerate, (state) => ({
    ...state,
    generate: createDefaultLoadable()
  })),
  on(AlertReportTemplateActions.notifyRecipients, (state) => ({
    ...state,
    notify: onLoadableLoad(state.notify)
  })),
  on(AlertReportTemplateActions.notifyRecipientsSuccess, (state) => ({
    ...state,
    notify: onLoadableSuccess(state.notify)
  })),
  on(AlertReportTemplateActions.notifyRecipientsFailure, (state, { error }) => ({
    ...state,
    notify: onLoadableError(state.notify, error)
  })),
  on(AlertReportTemplateActions.resetNotify, (state) => ({
    ...state,
    notify: createDefaultLoadable()
  })),
  on(AlertReportTemplateActions.exportAlerts, (state) => ({
    ...state,
    export: onLoadableLoad(state.export)
  })),
  on(AlertReportTemplateActions.exportAlertsSuccess, (state) => ({
    ...state,
    export: onLoadableSuccess(state.export)
  })),
  on(AlertReportTemplateActions.exportAlertsFailure, (state, { error }) => ({
    ...state,
    export: onLoadableError(state.export, error)
  })),
  on(AlertReportTemplateActions.resetExport, (state) => ({
    ...state,
    export: createDefaultLoadable()
  }))
);
